























import { Vue, Component, Prop } from "vue-property-decorator";
import PerfectScrollbar from 'perfect-scrollbar'
@Component({
  name: 'CardComponent'
})
export default class CardComponent extends Vue {
  ps: PerfectScrollbar;
  @Prop({
    type: String,
    default: null
  })
  title;

  @Prop({
    type: String,
    default: null
  })
  icon;

  @Prop({
    type: String,
    default: null
  })
  headerIcon;

  @Prop({
    type: Boolean,
    default: false
  })
  hasTitleSlot;

  @Prop({
    type: Boolean,
    default: false
  })
  hasButtonSlot;

  @Prop({
    type: Boolean,
    default: false
  })
  hasFooterSlot;

  @Prop({
    type: Boolean,
    default: false
  })
  hasCardHeaderBackground;

  @Prop({
    type: Boolean,
    default: false
  })
  isScrollable;

  headerIconClick() {
    this.$emit('header-icon-click')
  }

  mounted() {
    if (this.isScrollable) {
      this.ps = new PerfectScrollbar(this.$refs.cardContent as Element, {
        suppressScrollX: true
      })

      this.$emit('ps-ready', this.ps)
    }
  }
}
